// Column keys double as the backend sort keys (DraftFilters::LIST_SORTABLE) so ResponsiveTable's
// sort arrows light up against `filters.sort` with no translation layer. Status is not sortable
// (matches the legacy /drafts-list page).

export function buildColumns() {
  return [
    { key: 'name', label: 'Draft', sortable: true, minWidth: '180px' },
    { key: 'committee', label: 'Committee', sortable: true, minWidth: '160px' },
    // Wider than a plain zone-code column (Horses' equivalent is 90px) — this cell also carries
    // the "Final" badge next to the code, which clipped/wrapped awkwardly at 90px. Kept as a
    // fixed `width` (not `minWidth`) so it doesn't compete for flex space with Draft/Committee.
    { key: 'zone', label: 'Zone', sortable: true, width: '145px' },
    { key: 'start_date', label: 'From', sortable: true, width: '110px' },
    { key: 'end_date', label: 'To', sortable: true, width: '110px' },
    { key: 'actions', label: 'Actions', width: '150px', minWidth: '150px', cellClass: 'text-left' }
  ]
}

// Below 900px the row collapses into an accordion: the draft name stays visible, the rest
// drops into the expanded detail — matching the legacy DataTable expandedHeader / expandedRow.
export function buildBreakpoints() {
  return [
    {
      maxWidth: 900,
      hideHeader: true,
      accordion: {
        summary: [{ keys: ['name'], hideLabel: true }]
      },
      rows: [
        ['committee'],
        ['zone'],
        ['start_date'],
        ['end_date'],
        ['actions']
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/Drafts/Listing/columns.js